export default function(source, keys) {
  return Array.from(keys, key => source[key]);
}



//////////////////
// WEBPACK FOOTER
// /srv/http/murdocktrust.org/releases/458/web/app/themes/murdock-serenity/node_modules/d3-array/src/permute.js
// module id = 106
// module chunks = 0